import { Goal, ID } from '@griply/types';

import { getSubGoals } from './get-sub-goals';
import { createGoalTreeIndex } from './goal-tree-index';
import { isTaskMeasuredGoal } from './is-task-measured-goal';

// Progress rolls sub-goal tasks up, so a task-measured goal needs its whole sub-tree loaded.
export const getGoalProgressGoalIds = (goals: Goal[]): ID[] => {
  const progressGoals = goals.filter(isTaskMeasuredGoal);

  if (!progressGoals.length) {
    return [];
  }

  // Shared so getSubGoals doesn't rebuild the parent map per project.
  const index = createGoalTreeIndex(goals);

  const ids = new Set<ID>();
  progressGoals.forEach((goal) => {
    ids.add(goal.id);
    getSubGoals(goal.id, { goals, recursive: true, index }).forEach(({ id }) =>
      ids.add(id),
    );
  });

  return [...ids];
};
